export const SDK_VERSION = '7.119.0';



// WEBPACK FOOTER //
// ../../src/version.ts